import MuiStack, { StackProps } from '@mui/material/Stack';

export interface IStackProps extends StackProps {}

const Stack = (props: IStackProps): JSX.Element => {
  return <MuiStack {...props} />;
};

export default Stack;
